// Import firebase
import { firebaseAuth, propertiesModel } from '@/firebase/firebase-config'

// Import the mixins
import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'
import { SpinnerMethods } from '@/mixins/helpers/SpinnerMethods'
import { GenerateUID } from '@/mixins/helpers/GenerateUID'
import { InvoiceEventsRepository } from '@/repositories/invoice-events/InvoiceEventsRepository'

export const UpdatePaidInvoice = {

    /*
	**  Register the mixins
	*/

	mixins: [

        BugsnagService,
        SpinnerMethods,
        GenerateUID,
        InvoiceEventsRepository

    ],

    /*
	**  Set up the data
	*/

	data: () => ({

        error: false

    }),

    /*
	**  Methods
    */
    
    methods: {

        updatePaidInvoiceHandler: function() {

            try {

                /*
                **  Update the invoice to paid
                **  @method: @here
                */

                propertiesModel.doc(this.$route.params.id).collection('leases').doc(this.invoice.relationships.lease).collection('rents').doc(this.invoice.relationships.rent).collection('invoices').doc(this.invoice.id).update({
                    'attributes.description': this.invoice.attributes.description,
                    'attributes.status': this.invoice.attributes.status,
                    'meta.updated_at': moment().unix()
                })
                .then(() => {

                    /*
                    **  Set up the new invoice event
                    **  @method: @here
                    */

                    if (!this.error) this.setInvoiceEventDataPaid();

                })
                .then(() => {

                    /*
                    **  Create the invoice invent
                    **  @method: @here
                    */

                    if (!this.error) this.createInvoiceEventPaid();

                })
                .then(() => {

                    /*
                    ** Add payment to the rent term metrics
                    ** @location: @here
                    */

                    if (!this.error) this.updateRentMetricsPaidStats();

                })
                .then(() => {

                    /* 
                    ** Finish the update
                    ** @method: @here
                    */

                    if (!this.error) this.finishUpdatePaid();

                })
                .then(() => {

                    /* 
                    ** If error, handle it
                    ** @method: @here
                    */

                    if (this.error) this.handleErrorPaidStatus();

                })
                .catch(error => {

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */
                
                    this.reportAuthBugsnagError({
                        title: 'Update Invoice Status to Paid in Firestore',
                        errorType: 'Firestore Database',
                        section: 'Events/Invoices',
                        uid: 'WB0cCKXdwJsqFn2dkpuQ',
                        error: error
                    });

                });

            } catch (e) {

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */
            
                this.reportAuthBugsnagError({
                    title: 'Unable to Query Firestore When Updating an Invoice Status to Paid.',
                    errorType: 'Firestore Database',
                    section: 'Events/Invoices',
                    uid: 'sNo37LozZbMbSPKoslcG',
                    error: e
                });

            }

        },

        handleErrorPaidStatus: function() {

            /* 
            ** Close the modal
            ** @location: Components/Property/Lease/Invoices/EditInvoiceModal
            */

            this.closeTheModal();

            /* 
            ** Hide the spinner
            ** @location: Mixins/Helpers/SpinnerMethods
            */

            this.hideSpinner();

            /* 
            ** Display error message
            ** @service: @Window/SweetAlert
            */

            this.$swal('Uh Oh!', 'We ran into a problem trying to update the invoice.', 'error');

        },

        setInvoiceEventDataPaid: function() {

            /*
            **  Set the invoice event data
            **  @location: Repositories/InvoiceEvents
            */

            try {

                /*
                **  Set the paid amount
                */

                let amount = Number(this.invoice.attributes.charge.total) / 100;

                this.new_invoice_event.id = this.generateUID();
                this.new_invoice_event.type = 'invoice.update';
                this.new_invoice_event.attributes.title = 'A payment has been made in the amount of $' + amount + ' for ' + this.user.attributes.profile.first_name + ' ' + this.user.attributes.profile.last_name + ', on ' + moment().format() + '.';
                this.new_invoice_event.attributes.application = 'Nestd | Web';
                this.new_invoice_event.attributes.source = 'Nestd - ' + firebaseAuth.currentUser.displayName;
                this.new_invoice_event.attributes.request = {
                    status: this.invoice.attributes.status,
                    description: this.invoice.attributes.description
                };
                this.new_invoice_event.attributes.response = this.invoice;
                this.new_invoice_event.relationships.company = this.invoice.relationships.company;
                this.new_invoice_event.relationships.resident = this.invoice.relationships.resident;
                this.new_invoice_event.relationships.invoice = this.invoice.id;
                this.new_invoice_event.relationships.unit = this.invoice.relationships.unit;
                this.new_invoice_event.relationships.property = this.invoice.relationships.property;
                this.new_invoice_event.relationships.lease = this.invoice.relationships.lease;
                this.new_invoice_event.relationships.rent = this.invoice.relationships.rent;

            } catch (e) {

                /*
                **  Set the error prop
                **  @prop: @here
                */

                this.error = true;

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */
                
                this.reportAuthBugsnagError({
                    title: 'Setting the invoice event data when updating invoice to paid status.',
                    errorType: 'Application',
                    section: 'Events/Invoices',
                    uid: 'hagO9KLaRw0uxYlzB3Iu',
                    error: e
                });

            }

        },

        createInvoiceEventPaid: function() {

            try {

                /* 
                ** Create an invoice event
                ** @location: Repositories/Invoices/InvoiceEventsRepository
                */

                propertiesModel.doc(this.invoice.relationships.property).collection('leases').doc(this.invoice.relationships.lease).collection('rents').doc(this.invoice.relationships.rent).collection('invoices').doc(this.invoice.id).collection('events').doc(this.new_invoice_event.id).set(this.new_invoice_event)
                .catch(error => {

                    /*
                    **  Set the error prop
                    **  @prop: @here
                    */

                    this.error = true;

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */
                
                    this.reportAuthBugsnagError({
                        title: 'Create New Invoice Event in Firestore',
                        errorType: 'Firestore Database',
                        section: 'Events/Invoices',
                        uid: 'uO4b3qnpB9D10v5j8Gu7',
                        error: error
                    });

                });

                /* 
                ** Create a resident event
                ** @location: Repositories/Invoices/InvoiceEventsRepository
                */

                propertiesModel.doc(this.invoice.relationships.property).collection('residents').doc(this.invoice.relationships.resident).collection('events').doc(this.new_invoice_event.id).set(this.new_invoice_event)
                .catch(error => {

                    /*
                    **  Set the error prop
                    **  @prop: @here
                    */

                    this.error = true;

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */
                
                    this.reportAuthBugsnagError({
                        title: 'Create New Resident Event in Firestore',
                        errorType: 'Firestore Database',
                        section: 'Events/Invoices',
                        uid: 'bdN5yzknObfddVgWoKb1',
                        error: error
                    });

                });

            } catch (e) {

                /*
                **  Set the error prop
                **  @prop: @here
                */

                this.error = true;

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */
            
                this.reportAuthBugsnagError({
                    title: 'Unable to Query Firestore When Creating a New Invoice Event.',
                    errorType: 'Firestore Database',
                    section: 'Events/Invoices',
                    uid: 'PoL0YmXuxm5YX8qrfmXQ',
                    error: e
                });

            }

        },

        updateRentMetricsPaidStats: function() {

            try {

                /*
                **  Calculate metrics
                */

                let total_paid = this.rent.metrics.total_paid + 1,
                total_paid_amount = this.rent.metrics.total_paid_amount + this.invoice.attributes.charge.total;

                /*
                **  Update the doc
                **  @service: Firebase/Firestore
                */

                propertiesModel.doc(this.$route.params.id).collection('leases').doc(this.lease_id).collection('rents').doc(this.rent_id).update({
                    
                    'metrics.total_paid': total_paid,
                    'metrics.total_paid_amount': total_paid_amount,
                    'meta.updated_at': moment().unix()

                })
                .catch(error => {

                    /*
                    **  Set the error prop
                    **  @prop: @here
                    */

                    this.error = true;

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

                    this.reportAuthBugsnagError({
                        title: 'Update Total Late Metrics in Firestore',
                        errorType: 'Firestore Database',
                        section: 'Events/Invoices',
                        uid: 'nVUdVljXitQ3EH2G5CDU',
                        error: error
                    });

                });

            } catch (e) {

                /*
                **  Set the error prop
                **  @prop: @here
                */

                this.error = true;

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */

                this.reportAuthBugsnagError({
                    title: 'Unable to Query Firestore When Updating the Total Late Metrics.',
                    errorType: 'Firestore Database',
                    section: 'Events/Invoices',
                    uid: 'G5Jzvo0VPGzkq0xGAXrY',
                    error: e
                });

            }

        },

        finishUpdatePaid: function() {

            try {

                /* 
                ** Emit the refresh invoice event
                ** @service: @Vue
                */

                this.$emit('refreshInvoice', this.invoice);

                /* 
                ** Close the modal
                ** @location: Components/Property/Lease/Invoices/EditInvoiceModal
                */

                this.closeTheModal();

                /* 
                ** Hide the spinner
                ** @location: Mixins/Helpers/SpinnerMethods
                */

                this.hideSpinner();

                /* 
                ** Display success message
                ** @service: @Window/SweetAlert
                */

                this.$swal('Success!', 'Your rent invoice has been updated.', 'success');

            } catch (e) {

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */

                this.reportAuthBugsnagError({
                    title: 'Unable to Finish Up the Paid Invoice Update.',
                    errorType: 'Application',
                    section: 'Events/Invoices',
                    uid: 'TjqAdydQ2pNgC0URS2vz',
                    error: e
                });

            }

        }

    }

}